// Service for the Attendance Dashboard "Mi equipo" — "Situación de asistencia" employee status
// table (ASIS-5408 / REXASIS-007).
// GET /attendance/my-team/today/employees?page=1&pageSize=10&orderBy=statusCode
//   &orderDirection=ASC&companyIds=1,2&employeeIds=10,15&statusFilter=ABSENT,LATE&searchText=juan
//
// The backend wraps its `LC_PagedResult<LC_TodayEmployeeStatusItemOut>` in an `employees`
// property, but `ResponseEnvelopeHelper` (WebApiBase/Common) flattens that wrapper on the wire —
// the envelope's `data` ends up holding the paged shape directly, same as every other paginated
// GET endpoint in the project (see AttendanceConceptService.list for the reference pattern).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse, LC_PagedResult } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_TodayEmployeeStatusItemOut,
  GetMyTeamTodayEmployeeStatusListParams,
  MyTeamTodayEmployeeStatusListPage,
} from '../types/myTeamTodayEmployeeStatus.types';
import { mapMyTeamTodayEmployeeStatusItem } from '../mappers/myTeamTodayEmployeeStatus.mapper';


export class MyTeamTodayEmployeeStatusService {
  async list(
    params: GetMyTeamTodayEmployeeStatusListParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamTodayEmployeeStatusListPage>> {
    const query = buildQueryString({
      page: params.page,
      pageSize: params.pageSize,
      orderBy: params.orderBy,
      orderDirection: params.orderDirection,
      companyIds: params.companyIds?.map(String),
      employeeIds: params.employeeIds?.map(String),
      statusFilter: params.statusFilter,
      searchText: params.searchText,
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_TODAY_EMPLOYEES}${query}`;

    const response = await apiClient.get<LC_PagedResult<LC_TodayEmployeeStatusItemOut>>(
      endpoint,
      { signal },
    );

    if (response.success && response.data) {
      return {
        success: true,
        data: {
          items: (response.data.data ?? []).map(mapMyTeamTodayEmployeeStatusItem),
          totalRecords: response.data.pagination.totalRecords,
        },
      };
    }

    return { success: false, data: null, error: response.error };
  }
}

export const myTeamTodayEmployeeStatusService = new MyTeamTodayEmployeeStatusService();
